import { FunctionComponent } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import OrganizationAssetDetails from './OrganizationAssetDetails';
import OrganizationAssetsList from './OrganizationAssetsList';

const OrganizationAssets: FunctionComponent = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/:id`} component={OrganizationAssetDetails} />
      <Route path={''} component={OrganizationAssetsList} />
    </Switch>
  );
};

export default OrganizationAssets;
